import { useEffect, useState } from 'react'

export function useNanoRouter() {
  return { ...useNanoLocation(), navigate: nanoNavigate }
}

function useNanoLocation() {
  const [nanoLocation, setNanoLocation] = useState({
    pathname: location.pathname,
    search: location.search,
  })

  useEffect(() => {
    const onChange = () => {
      setNanoLocation({ pathname: location.pathname, search: location.search })
    }
    window.addEventListener('popstate', onChange)
    return () => {
      window.removeEventListener('popstate', onChange)
    }
  }, [])

  return {
    location: nanoLocation.pathname,
    searchParams: new URLSearchParams(nanoLocation.search),
  }
}

export function nanoNavigate(url: string, options?: { replace?: boolean }) {
  const r = url ? location.protocol + url : window.location.origin
  const method = options?.replace ? 'replaceState' : 'pushState'
  history[method](null, '', r) // doesn't cause a request (but when you update url and press enter, it causes a request)
  dispatchEvent(new PopStateEvent('popstate', { state: null })) // to call setCutLocation
}
